
import { overflowContainerMixin } from '../../mixins'
import { createPopup, createWidget } from '@typeform/embed'
import '@typeform/embed/build/css/popup.css'
import EoButton from '../EoButton/EoButton'

export default {
  name: 'EoTypeform',
  components: {
    EoButton,
  },
  mixins: [overflowContainerMixin],
  props: {
    /**
     * Embed id or iframe url
     */
    id: {
      type: String,
      default: '',
    },
    /**
     * Type (popup or inline)
     */
    type: {
      type: String,
      default: 'inline',
      validator: (value) => {
        return value.includes('inline') || value.includes('popup')
      },
    },
    /**
     * buttonColor (color for the button)
     */
    buttonColor: {
      type: String,
      default: 'primary',
    },
    /**
     * buttonLabel (text for the label)
     */
    buttonLabel: {
      type: String,
      default: 'Formulier openen',
    },
    /**
     * buttonText (text to show in the button)
     */
    buttonText: {
      type: String,
      default: 'Formulier openen',
    },
    /**
     * textColor (color for the text)
     */
    textColor: {
      type: String,
      default: 'white',
    },
    /**
     * icon (icon to show in the button)
     */
    icon: {
      type: String,
      default: null,
    },
    /**
     * Height (percentage of width OR px OR vh)
     */
    height: {
      type: String,
      default: '600px', // default: Typeform embed (standard) height
      validator: (value) => {
        return value.includes('px') || value.includes('vh') || value.includes('%')
      },
    },
    /**
     * Max height (pixels)
     */
    maxHeight: {
      type: String,
      default: null,
      validator: (value) => {
        return value.includes('px') || value.includes('vh')
      },
    },
  },
  data () {
    return {
      close: () => {},
      open: () => {},
      refresh: () => {},
      toggle: () => {},
    }
  },
  computed: {
    rootStyles () {
      return {
        maxHeight: (this.maxHeight?.includes('px') || this.maxHeight?.includes('vh')) && this.maxHeight,
      }
    },
    containerStyles () {
      return {
        height: (this.height?.includes('px') || this.height?.includes('vh')) ? this.height : '0',
        paddingBottom: (this.height?.includes('px') || this.height?.includes('vh')) ? '0' : this.height?.includes('%') && this.height,
      }
    },
    normalizedId () {
      // Possible entered values:
      // - chZMmv3z
      // - https://evangelischeomroep.typeform.com/to/chZMmv3z
      // - https://evangelischeomroep.typeform.com/to/chZMmv3z?typeform-source=admin.typeform.com
      if (!this.id) return ''

      const idInUrlPrefix = 'typeform.com/to/'
      if (this.id.includes(idInUrlPrefix)) {
        /// ID entered is a URL
        const idWithoutDomain = this.id.substr(this.id.indexOf(idInUrlPrefix) + idInUrlPrefix.length)
        return idWithoutDomain.includes('?') ? idWithoutDomain.substr(0, idWithoutDomain.indexOf('?')) : idWithoutDomain
      } else {
        /// ID entered directly
        return this.id
      }
    },
  },
  mounted () {
    if (this.normalizedId && this.type === 'inline') {
      const { refresh } = createWidget(this.normalizedId, {
        container: this.$refs.embed,
        inlineOnMobile: true,
        height: this.height,
      })
      this.refresh = refresh
    }
  },
  methods: {
    createPopup () {
      if (this.normalizedId && this.type === 'popup') {
        const { open, close, toggle, refresh } = createPopup(this.normalizedId, {
          container: this.$library.application?.$el || document.body,
          size: '90', // config only for popup
        })
        this.open = open
        this.close = close
        this.toggle = toggle
        this.refresh = refresh
        open()
      }
    },
  },
}
